/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Safe_Light_Calf_DashInputs */

const en_safe_light_calf_dash = /** @type {(inputs: Safe_Light_Calf_DashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete selected users?`)
};

const de_safe_light_calf_dash = /** @type {(inputs: Safe_Light_Calf_DashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgewählte Nutzer löschen?`)
};

/**
* | output |
* | --- |
* | "Delete selected users?" |
*
* @param {Safe_Light_Calf_DashInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const safe_light_calf_dash = /** @type {((inputs?: Safe_Light_Calf_DashInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Safe_Light_Calf_DashInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_safe_light_calf_dash(inputs)
	return de_safe_light_calf_dash(inputs)
});